import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  sucursales: z.array(z.object({
    value: z.string(),
    label: z.string()
  })).optional().default([]),
  estatus: z.union([z.string(), z.number()]).optional(),
})
